const apiOrigins = {
  development: 'https://api-dev.eu.i2x.ai',
  production: 'https://api.eu.i2x.ai'
} as const;

const appEnvironment = import.meta.env.VITE_APP_ENV === 'production' ? 'production' : 'development';
const defaultManagementControlUrl = `${apiOrigins[appEnvironment]}/organizations`;

/** Explicit local-development escape hatch. Never inferred from mode: a
 * production build remains gated unless its operator deliberately opts out. */
export const authDisabled = import.meta.env.VITE_AUTH_DISABLED === 'true';

/**
 * There is one way in: i2x Management Control issues a JWT and every API call
 * carries it as a bearer token.
 *
 * The archive used to have a login of its own — user and password from the Go
 * server's config, answered with a session cookie. It is gone, along with the
 * accounts: the backend now verifies Management Control's signature and reads
 * the company out of the token to decide which archive the request may see, so a
 * second way to sign in would be a second, weaker answer to that question.
 */
export const endpoints = {
  archiveApi: (import.meta.env.VITE_API_BASE_URL ?? '').replace(/\/$/, ''),
  managementControl: (import.meta.env.VITE_MANAGEMENT_CONTROL_URL || defaultManagementControlUrl).replace(/\/$/, '')
} as const;
